import { CALL_API } from "admin/middlewares/api";

export const INIT_STATUS_GET_REQUEST = "INIT_STATUS_GET_REQUEST";
export const INIT_STATUS_GET_SUCCESS = "INIT_STATUS_GET_SUCCESS";
export const INIT_STATUS_GET_ERROR = "INIT_STATUS_GET_ERROR";

export function get_init_status() {
  let uri = "/api/admin/system/initstatus";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        INIT_STATUS_GET_REQUEST,
        INIT_STATUS_GET_SUCCESS,
        INIT_STATUS_GET_ERROR,
      ],
    },
  };
}

export const INIT_SYSTEM_REQUEST = "INIT_SYSTEM_REQUEST";
export const INIT_SYSTEM_SUCCESS = "INIT_SYSTEM_SUCCESS";
export const INIT_SYSTEM_ERROR = "INIT_SYSTEM_ERROR";

export function init_system() {
  let uri = "/api/admin/system/init";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      types: [INIT_SYSTEM_REQUEST, INIT_SYSTEM_SUCCESS, INIT_SYSTEM_ERROR],
    },
  };
}

export const RESET_STATUS_GET_REQUEST = "RESET_STATUS_GET_REQUEST";
export const RESET_STATUS_GET_SUCCESS = "RESET_STATUS_GET_SUCCESS";
export const RESET_STATUS_GET_ERROR = "RESET_STATUS_GET_ERROR";

export function get_reset_status() {
  let uri = "/api/admin/system/resetstatus";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        RESET_STATUS_GET_REQUEST,
        RESET_STATUS_GET_SUCCESS,
        RESET_STATUS_GET_ERROR,
      ],
    },
  };
}

export const RESET_SYSTEM_REQUEST = "RESET_SYSTEM_REQUEST";
export const RESET_SYSTEM_SUCCESS = "RESET_SYSTEM_SUCCESS";
export const RESET_SYSTEM_ERROR = "RESET_SYSTEM_ERROR";

export function reset_system() {
  let uri = "/api/admin/system/reset";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      types: [RESET_SYSTEM_REQUEST, RESET_SYSTEM_SUCCESS, RESET_SYSTEM_ERROR],
    },
  };
}

export const SET_MAINTENANCE_REQUEST = "SET_MAINTENANCE_REQUEST";
export const SET_MAINTENANCE_SUCCESS = "SET_MAINTENANCE_SUCCESS";
export const SET_MAINTENANCE_ERROR = "SET_MAINTENANCE_ERROR";

export function set_maintenance(mode) {
  let uri = "/api/admin/system/maintenance";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      data: { Mode: mode },
      types: [INIT_SYSTEM_REQUEST, INIT_SYSTEM_SUCCESS, INIT_SYSTEM_ERROR],
    },
  };
}

export const RESTART_ROUTER_REQUEST = "RESTART_ROUTER_REQUEST";
export const RESTART_ROUTER_SUCCESS = "RESTART_ROUTER_SUCCESS";
export const RESTART_ROUTER_ERROR = "RESTART_ROUTER_ERROR";

export function restart_router() {
  let uri = "/api/admin/system/services/eventrouter/restart";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      types: [
        RESTART_ROUTER_REQUEST,
        RESTART_ROUTER_SUCCESS,
        RESTART_ROUTER_ERROR,
      ],
    },
  };
}

export const RESTART_PROJECTIONS_REQUEST = "RESTART_PROJECTIONS_REQUEST";
export const RESTART_PROJECTIONS_SUCCESS = "RESTART_PROJECTIONS_SUCCESS";
export const RESTART_PROJECTIONS_ERROR = "RESTART_PROJECTIONS_ERROR";

export function restart_projections() {
  let uri = "/api/admin/system/services/projections/restart";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "POST",
      types: [
        RESTART_PROJECTIONS_REQUEST,
        RESTART_PROJECTIONS_SUCCESS,
        RESTART_PROJECTIONS_ERROR,
      ],
    },
  };
}

export const GET_EVENT_LIST_REQUEST = "GET_EVENT_LIST_REQUEST";
export const GET_EVENT_LIST_SUCCESS = "GET_EVENT_LIST_SUCCESS";
export const GET_EVENT_LIST_ERROR = "GET_EVENT_LIST_ERROR";

export function get_event_list(from, to) {
  let uri = "/api/admin/system/events/ByTimeSpan?From=" + from + "&to=" + to;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_EVENT_LIST_REQUEST,
        GET_EVENT_LIST_SUCCESS,
        GET_EVENT_LIST_ERROR,
      ],
    },
  };
}

export const EVENT_LIST_CHANGE_PAGE = "EVENT_LIST_CHANGE_PAGE";

export function change_event_list_page(page) {
  return {
    type: EVENT_LIST_CHANGE_PAGE,
    page,
  };
}

export const EVENT_LIST_CHANGE_FILTER = "EVENT_LIST_CHANGE_FILTER";

export function change_event_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: EVENT_LIST_CHANGE_FILTER,
    filter,
  };
}

//By key endpoints for events

export const GET_EVENT_BY_KEY_LIST_REQUEST = "GET_EVENT_BY_KEY_LIST_REQUEST";
export const GET_EVENT_BY_KEY_LIST_SUCCESS = "GET_EVENT_BY_KEY_LIST_SUCCESS";
export const GET_EVENT_BY_KEY_LIST_ERROR = "GET_EVENT_BY_KEY_LIST_ERROR";

export function get_event_list_by_key(key) {
  let trimmedKey = key.replace(/\s/g, "");
  let uri = "/api/admin/system/events/bystreamkey?StreamKey=" + trimmedKey;

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_EVENT_BY_KEY_LIST_REQUEST,
        GET_EVENT_BY_KEY_LIST_SUCCESS,
        GET_EVENT_BY_KEY_LIST_ERROR,
      ],
    },
  };
}

export const EVENT_BY_KEY_LIST_CHANGE_PAGE = "EVENT_BY_KEY_LIST_CHANGE_PAGE";

export function change_event_by_key_list_page(page) {
  return {
    type: EVENT_BY_KEY_LIST_CHANGE_PAGE,
    page,
  };
}

export const EVENT_BY_KEY_LIST_CHANGE_FILTER =
  "EVENT_BY_KEY_LIST_CHANGE_FILTER";

export function change_event_by_key_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: EVENT_BY_KEY_LIST_CHANGE_FILTER,
    filter,
  };
}
